<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{titleCaption}}
    </div>
</div>
<div [formGroup]="delegationFormGroup" mat-dialog-content class="nova__dialog__content">
    <ng-container *ngIf="!delegation">
        <mat-form-field appearance="outline" class="form-field">
            <input matInput type="text" placeholder="Add delegate*" #employeeSearchInput formControlName="employeeSearch" [matAutocomplete]="auto">
            <mat-autocomplete data-qa-id="DelegationAddEditEmployeeSearchInput" #auto="matAutocomplete"
                [displayWith]="employeeDisplay" (optionSelected)="employeeSelected($event)">
                <mat-option *ngFor="let employee of employees$ | async" [value]="employee">
                    {{ employee?.fullName }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </ng-container>
    <div class="delegated-user margin-bottom" *ngIf="delegation">
        <div class="flex-col">
            <div class="flex-row space-between items-center">
                <span class="delegated-user-name-label" data-qa-id="delegated-user-name">{{delegation.delegatedUser.name}}</span>
            </div>
            <div class="flex-row items-center">
                <span class="delegated-user-title-label" data-qa-id="delegated-user-title" *ngIf="delegation.delegatedUser.title">{{delegation.delegatedUser.title}}</span>
            </div>
        </div>
    </div>
    <div class="margin-bottom">
        <div class="delegation-types-label">Select the permission(s) for this delegate*</div>
        <div class="delegation-types flex-row-wrap space-between items-start">
            <mat-selection-list formControlName="delegationTypes">
                <mat-list-option
                    *ngFor="let type of delegationTypeOptions"
                    [value]="type.key"
                    checkboxPosition="before"
                    class="option-wrapper">
                    <span class="option">{{ type.value }}</span>
                </mat-list-option>
            </mat-selection-list>
        </div>
    </div>

    <div class="date-time-pickers">
        <div class="timeframe-label">Set a timeframe *</div>
        <div class="timeframe-help-text">Not setting an end date will classify your coverage as “ongoing”. You are required to manually stop your coverage.</div>
        <div class="flex-row space-between">
            <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="startDatePicker" formControlName="delegationStartDate"
                    [max]="getStartMaxDateValue()">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker data-qa-id="DelegationAddEditStartDatePicker" #startDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="endDatePicker" formControlName="delegationEndDate"
                    [min]="getEndMinDateValue()">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker data-qa-id="DelegationAddEditEndDatePicker" #endDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <mat-dialog-actions class="nova__dialog__content__actions">
        <button data-qa-id="DelegationAddEditSaveButton" mat-flat-button color="primary" [disabled]="!delegationFormGroup.valid || !delegationFormGroup.dirty" (click)="saveDelegation()">
            {{saveCaption}}
        </button>
        <button data-qa-id="DelegationAddEditCancelButton" mat-flat-button color="cancel" [mat-dialog-close]="false">
            Cancel
        </button>
    </mat-dialog-actions>
</div>
